"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AXIS_TYPES = void 0;
/* eslint-disable react-hooks/rules-of-hooks */
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importStar(require("react"));
const Axis_1 = __importDefault(require("../../components/Axis"));
const Bars_1 = __importDefault(require("../../components/Bars"));
const ChartWrapper_1 = __importStar(require("../../components/ChartWrapper"));
const ConnectedDots_1 = __importDefault(require("../../components/ConnectedDots"));
const EllipsizedLabel_1 = __importDefault(require("../../components/EllipsizedLabel"));
const Footnotes_1 = require("../../components/Footnotes");
const Gridlines_1 = __importStar(require("../../components/Gridlines"));
const LabelContainer_1 = __importDefault(require("../../components/LabelContainer"));
const Sources_1 = require("../../components/Sources");
const Tooltip_1 = __importStar(require("../../components/Tooltip"));
const TooltipContent_1 = __importDefault(require("../../components/Tooltip/TooltipContent"));
const utilities_1 = require("../../utilities");
const colors_1 = require("../../utilities/colors");
const constants_1 = require("../../utilities/constants");
const date_1 = require("../../utilities/date");
const format_1 = require("../../utilities/format");
const measurements_1 = require("../../utilities/measurements");
const types_1 = require("../../utilities/types");
const constants_2 = require("./constants");
const helpers_1 = require("./helpers");
const useDotPlotAxis_1 = __importDefault(require("./useDotPlotAxis"));
const AXIS_FONTSIZE_TO_HEIGHT_MULTIPLIER = 1.2;
const MIN_HEIGHT = 150;
const CHART_TOP_SPACING = 20;
exports.AXIS_TYPES = (0, lodash_1.default)(format_1.VALUE_FORMATS).omit(['default']).keys().value();
const DotPlot = _ref => {
  let {
    data: rawData,
    dataSeriesHeight = constants_2.DEFAULT_DATA_SERIES_HEIGHT,
    dataSeriesOptions: rawDataSeriesOptions = [],
    dotOptions = constants_2.DEFAULT_DOT_OPTIONS,
    dropdownOptions = constants_2.DEFAULT_DROPDOWN_OPTIONS,
    featuredPosition = constants_2.DEFAULT_FEATURED_POSITION,
    footerOptions = constants_2.DEFAULT_FOOTER_OPTIONS,
    labelOptions = constants_2.DEFAULT_LABEL_OPTIONS,
    sort = constants_2.DEFAULT_SORT,
    subtitleOptions = constants_2.DEFAULT_SUBTITLE_OPTIONS,
    titleOptions = constants_2.DEFAULT_TITLE_OPTIONS,
    tooltipOptions = constants_2.DEFAULT_TOOLTIP_OPTIONS,
    height,
    width,
    xAxisOptions = constants_2.DEFAULT_X_AXIS_OPTIONS,
    customTooltip
  } = _ref;
  if (!rawData || !rawData.length) {
    return null;
  }
  if (height && height < MIN_HEIGHT) {
    console.warn(`Height cannot be lower than ${MIN_HEIGHT}.`);
  }
  /** Initialize options */
  const optsDot = lodash_1.default.defaultsDeep({}, dotOptions, constants_2.DEFAULT_DOT_OPTIONS);
  const optsDropdown = lodash_1.default.defaultsDeep({}, dropdownOptions, constants_2.DEFAULT_DROPDOWN_OPTIONS);
  const optsFooter = lodash_1.default.defaultsDeep({}, footerOptions, constants_2.DEFAULT_FOOTER_OPTIONS);
  const optsSubtitle = lodash_1.default.defaultsDeep({}, subtitleOptions, constants_2.DEFAULT_SUBTITLE_OPTIONS);
  const optsTitle = lodash_1.default.defaultsDeep({}, titleOptions, constants_2.DEFAULT_TITLE_OPTIONS);
  const optsTooltip = lodash_1.default.defaultsDeep({}, tooltipOptions, constants_2.DEFAULT_TOOLTIP_OPTIONS);
  const optsXAxis = lodash_1.default.defaultsDeep({}, xAxisOptions, constants_2.DEFAULT_X_AXIS_OPTIONS);
  const optsLabel = lodash_1.default.defaultsDeep({}, labelOptions, constants_2.DEFAULT_LABEL_OPTIONS);
  /** Prepare Metrics and Data */
  const rawDataIds = (0, utilities_1.getDataIds)(rawData);
  const rawDataSeriesOptionsIds = (0, utilities_1.getDataIds)(rawDataSeriesOptions);
  const optsDotValues = Object.values(optsDot);
  const {
    data
  } = (0, react_1.useMemo)(() => {
    const datasets = (0, utilities_1.extractDatasets)(rawData);
    const preparedDataSeriesOptions = (0, utilities_1.prepareDataSeriesOptions)(datasets, rawDataSeriesOptions);
    const dataSeriesOptions = (0, helpers_1.parseMetrics)(preparedDataSeriesOptions, optsDot);
    const data = (0, utilities_1.parseData)(datasets, dataSeriesOptions, ['name', 'x_type', 'y_type', 'sources', 'meta']).map(d => ({
      ...d,
      sources: d.sources || [],
      name: d.metric.labelText || d.name,
      tooltipTitle: d.metric.tooltipTitle || d.name
    }));
    return {
      data,
      dataSeriesOptions
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawDataIds, rawDataSeriesOptionsIds, optsDotValues]);
  /** Start Axis Setup */
  // We flip the data, so as to graph Y values along the xAxis
  const xType = (0, utilities_1.isValidAxisType)(optsXAxis.type) ? optsXAxis.type : (0, utilities_1.getAxisTypeFromData)(data, 'y') || constants_2.DEFAULT_X_TYPE;
  const yType = (0, utilities_1.isValidAxisType)(optsDropdown.type) ? optsDropdown.type : (0, utilities_1.getAxisTypeFromData)(data, 'x') || constants_2.DEFAULT_DROPDOWN_TYPE;
  const xAxisFormat = (0, utilities_1.valueFormat)({
    params: {
      format: xType
    }
  });
  const yAxisFormat = (0, utilities_1.valueFormat)({
    params: {
      format: yType
    }
  });
  const keys = (0, utilities_1.extractKeys)(data, date_1.dateParser).map(i => ({
    ...i,
    parsed: yAxisFormat(i.key)
  }));
  /** State */
  const [tooltip, setTooltip] = (0, react_1.useState)(null);
  const {
    key: selectedKey1,
    dropdown: dropdown1
  } = (0, utilities_1.useDropdown)({
    color: optsDot.dot1Color,
    defaultToFirst: true,
    enabled: optsDropdown.enabled,
    keys,
    label: optsTitle.text ? ' ' : '',
    parser: yAxisFormat,
    sortBy: optsDropdown.sort,
    targetKey: optsDropdown.selectedItem1
  });
  const {
    key: selectedKey2,
    dropdown: dropdown2
  } = (0, utilities_1.useDropdown)({
    color: optsDot.dot2Color,
    enabled: optsDropdown.enabled,
    keys,
    label: ' vs ',
    parser: yAxisFormat,
    sortBy: optsDropdown.sort,
    targetKey: optsDropdown.selectedItem2
  });
  const dropdowns = [];
  if (optsDropdown.show) {
    // remove the option selected in the other dropdown from options.
    if (dropdown1 && dropdown1.options) {
      const dropdown1Options = dropdown1.options.filter(option => option !== selectedKey2);
      dropdowns.push({
        ...dropdown1,
        options: dropdown1Options
      });
    }
    if (dropdown2 && dropdown2.options) {
      const dropdown2Options = dropdown2.options.filter(option => option !== selectedKey1);
      dropdowns.push({
        ...dropdown2,
        options: dropdown2Options
      });
    }
  }
  /** Resume Axis */
  const values = data.flatMap(_ref2 => {
    let {
      data
    } = _ref2;
    return data;
  }).filter(_ref3 => {
    let {
      key
    } = _ref3;
    return !optsXAxis.floatingAxis || key === selectedKey1 || key === selectedKey2;
  }).map(_ref4 => {
    let {
      value
    } = _ref4;
    return value;
  });
  const {
    ticks: xTicks,
    scale: xScale
  } = (0, useDotPlotAxis_1.default)({
    type: xType,
    values,
    customDomain: [optsXAxis.displayRangeMin, optsXAxis.displayRangeMax],
    customTicks: optsXAxis.ticks
  });
  /** Consts */
  const valuesAllNegative = xScale.domain()[1] <= 0;
  const valuesCrossZero = !valuesAllNegative && xScale.domain()[0] < 0 && xScale.domain()[1] > 0;
  const labelWidth = lodash_1.default.min([optsLabel.maxWidth, lodash_1.default.max([...data.map(i => (0, measurements_1.textDimensions)({
    text: i.name,
    fontSize: optsLabel.fontSize
  }).width)])]);
  const lastTickWidth = optsXAxis.displayTicks ? (0, measurements_1.textDimensions)({
    text: xAxisFormat(lodash_1.default.last(xTicks), !lodash_1.default.isNil(optsXAxis.decimals) ? {
      decimals: optsXAxis.decimals
    } : {
      ticks: xTicks
    }),
    fontSize: optsXAxis.fontSize
  }).width / 2 : 0;
  /** Chart Wrapper Parts */
  const {
    sources,
    summary
  } = (0, Sources_1.useSources)({
    data,
    chartSources: optsFooter.sources
  });
  const {
    footnotes
  } = (0, Footnotes_1.useFootnotes)({
    data,
    chartFootnotes: optsFooter.footnotes,
    showMetricFootnotes: optsFooter.showMetricFootnotes
  });
  /** Funcs */
  const onDotMouseOut = () => {
    setTooltip(null);
  };
  return react_1.default.createElement(ChartWrapper_1.default, {
    className: 'dot-chart',
    title: optsTitle.text,
    subtitle: optsSubtitle.text,
    titleFontSize: optsTitle.fontSize,
    subtitleFontSize: optsSubtitle.fontSize,
    footerSources: optsFooter.show ? sources : [],
    footerSummary: optsFooter.show ? summary : '',
    footnotes: optsFooter.show ? footnotes : [],
    showFooter: optsFooter.show,
    showMetricFootnotes: optsFooter.showMetricFootnotes,
    dropdowns: dropdowns,
    width: width,
    height: height,
    fontSize: optsFooter.fontSize,
    onMouseLeave: onDotMouseOut
  }, _ref5 => {
    let {
      chartWidth,
      chartHeight
    } = _ref5;
    xScale.range([labelWidth + constants_2.DEFAULT_LABEL_PADDING + constants_2.DEFAULT_LABEL_PADDING, chartWidth - lastTickWidth]);
    const dotData = (0, helpers_1.formatData)({
      data,
      selectedKey1,
      selectedKey2,
      featuredPosition,
      sort
    });
    const topAxisHeight = lodash_1.default.includes(optsXAxis.displayTicks, constants_2.AXIS_POSITIONS.top) ? optsXAxis.fontSize * AXIS_FONTSIZE_TO_HEIGHT_MULTIPLIER : 0;
    const bottomAxisHeight = lodash_1.default.includes(optsXAxis.displayTicks, constants_2.AXIS_POSITIONS.bottom) ? optsXAxis.fontSize * AXIS_FONTSIZE_TO_HEIGHT_MULTIPLIER : 0;
    const rowCount = dotData.length;
    const spacerCount = dotData.find(dd => dd.metric.featured) ? 1 : 0;
    const spacerHeight = spacerCount * constants_2.DEFAULT_FEATURED_BAR_SPACER_HEIGHT;
    let rowsHeight = rowCount * dataSeriesHeight;
    let rowHeight = dataSeriesHeight;
    if (height) {
      rowsHeight = chartHeight - CHART_TOP_SPACING - topAxisHeight - spacerHeight - bottomAxisHeight;
      rowHeight = Math.floor(rowsHeight / rowCount);
      rowsHeight = rowHeight * rowCount;
    }
    const svgheight = topAxisHeight + spacerHeight + rowsHeight + bottomAxisHeight;
    const minChartHeight = CHART_TOP_SPACING + svgheight;
    const {
      segments,
      spacers
    } = (0, helpers_1.initSegments)({
      fontSize: optsLabel.fontSize,
      height: rowHeight,
      data: dotData,
      initialY: topAxisHeight,
      textColor: (0, colors_1.parseColor)(optsLabel.color, constants_2.DEFAULT_TEXT_COLOR),
      xScale,
      chartWidth
    });
    function onDotMouseOver(e, dotIndex) {
      let dotNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      const dot = segments[dotIndex];
      if (!dot) {
        return;
      }
      const dotNum = dotNumber === undefined ? 0 : dotNumber;
      const dotDatum = dotData[dotIndex];
      // we do this to undo the reversal below, we want dot1 on top
      const reversedDots = [...dot.dots].reverse();
      const specificDatum = reversedDots[dotNum].data;
      const dotEl = reversedDots[dotNum].dot;
      if (!dotDatum || !specificDatum || !dotEl) {
        return;
      }
      setTooltip({
        position: {
          x: dotEl.x,
          y: dotEl.y + constants_1.DEFAULT_CHART_TOP_PADDING
        },
        value: specificDatum.value,
        direction: optsTooltip.position,
        title: dotDatum.tooltipTitle || dotDatum.name,
        color: dotEl.color,
        label: yAxisFormat(specificDatum.key),
        type: dotDatum.y_type
      });
    }
    return react_1.default.createElement("div", {
      style: {
        height: chartHeight,
        minHeight: minChartHeight,
        overflow: 'visible',
        position: 'relative',
        width: '100%'
      }
    }, react_1.default.createElement("div", {
      style: {
        height: CHART_TOP_SPACING
      }
    }), react_1.default.createElement("svg", {
      style: {
        overflow: 'visible'
      }
    }, topAxisHeight > 0 && react_1.default.createElement(Axis_1.default, {
      position: constants_2.AXIS_POSITIONS.top,
      chartWidth: chartWidth,
      chartHeight: svgheight,
      fontSize: optsXAxis.fontSize,
      textColor: (0, colors_1.parseColor)(optsXAxis.textColor, constants_2.DEFAULT_TEXT_COLOR),
      ticks: xTicks.map(tick => ({
        data: tick,
        point: xScale(tick)
      })),
      formatter: v => xAxisFormat(v, !lodash_1.default.isNil(optsXAxis.decimals) ? {
        decimals: optsXAxis.decimals
      } : {
        ticks: xTicks
      })
    }), bottomAxisHeight > 0 && react_1.default.createElement(Axis_1.default, {
      position: constants_2.AXIS_POSITIONS.bottom,
      chartWidth: chartWidth,
      chartHeight: svgheight,
      fontSize: optsXAxis.fontSize,
      textColor: (0, colors_1.parseColor)(optsXAxis.textColor, constants_2.DEFAULT_TEXT_COLOR),
      ticks: xTicks.map(tick => ({
        data: tick,
        point: xScale(tick)
      })),
      formatter: v => xAxisFormat(v, !lodash_1.default.isNil(optsXAxis.decimals) ? {
        decimals: optsXAxis.decimals
      } : {
        ticks: xTicks
      })
    }), (optsXAxis.showGridlines || valuesCrossZero) && react_1.default.createElement(Gridlines_1.default, {
      orientation: Gridlines_1.AXIS_ORIENTATIONS.vertical,
      range: [topAxisHeight, topAxisHeight + rowsHeight + spacerHeight],
      strokeWidth: 1,
      gridColor: colors_1.AXIS_LINE_COLOR,
      ticks: xTicks.filter(tick => optsXAxis.showGridlines || tick === 0).map(tick => ({
        point: xScale(tick),
        strokeWidth: valuesCrossZero && tick === 0 && optsXAxis.showGridlines ? 3 : 1
      }))
    }), react_1.default.createElement(LabelContainer_1.default, {
      labels: segments.map(_ref6 => {
        let {
          label
        } = _ref6;
        return {
          ...label,
          content: react_1.default.createElement(EllipsizedLabel_1.default, {
            dominantBaseline: "hanging",
            label: label.content,
            fontSize: label.style.fontSize,
            maxWidth: labelWidth,
            maxLines: optsLabel.maxLines
          })
        };
      }),
      onMouseOver: (e, i) => onDotMouseOver(e, i),
      onMouseOut: onDotMouseOut
    }), segments.map((_ref7, index) => {
      let {
        label: {
          key
        },
        dots,
        line
      } = _ref7;
      return react_1.default.createElement(ConnectedDots_1.default, {
        key: key,
        dots: dots.map(_ref8 => {
          let {
            dot
          } = _ref8;
          return dot;
        }).reverse(),
        lineWidth: line.width,
        lineColor: line.color,
        onMouseOver: (e, i) => onDotMouseOver(e, index, i),
        onMouseOut: onDotMouseOut
      });
    }), spacers.length > 0 && react_1.default.createElement(Bars_1.default, {
      bars: spacers
    })), optsTooltip.show && tooltip && react_1.default.createElement("div", null, react_1.default.createElement(Tooltip_1.default, {
      direction: tooltip.direction,
      x: tooltip.position.x,
      y: tooltip.position.y,
      width: chartWidth
    }, customTooltip ? customTooltip(tooltip, optsTooltip) : react_1.default.createElement(TooltipContent_1.default, {
      title: tooltip.title,
      subtitle: optsTooltip.showSubtitle ? tooltip.label : undefined,
      value: tooltip.value,
      color: tooltip.color,
      decimals: optsTooltip.decimals,
      type: tooltip.type
    }))));
  });
};
DotPlot.propTypes = {
  ...ChartWrapper_1.chartWrapperPropTypes,
  /**
   * Data for the chart.
   * @param datasets Data entries.
   * Each entry contains required params id, name, x_type, y_type and a data array
   * with key/value pairs.
   * Optional params of footnote, sources array and meta array
   * @param sources Data sources in the standard format. (see chartSources for structure)
   */
  data: (0, prop_types_1.oneOfType)([/** Data sources */
  (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.dataShape)), (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    /** State data entires */
    datasets: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.dataShape)),
    /** Data sources */
    sources: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(types_1.sourcesShape))
  }))]).isRequired,
  /** Height of data series row  */
  dataSeriesHeight: prop_types_1.number,
  /**
   * Defines which group and category each data belongs to. Allows override of some properties
   * @param id metric id
   * @param dot1Color {string} color of dot 1, overrides dotOptions
   * @param dot1Radius {number} radius of dot 1, overrides dotOptions
   * @param dot1StokeWidth {number} stroke width of dot 1, overrides dotOptions
   * @param dot1StrokeColor {string} stroke color of dot 1, overrides dotOptions
   * @param dot2Color {string} color of dot 2, overrides dotOptions
   * @param dot2Radius {number} radius of dot 2, overrides dotOptions
   * @param dot2StokeWidth {number} stroke width of dot 2, overrides dotOptions
   * @param dot2StrokeColor {string} stroke color of dot 2, overrides dotOptions
   * @param lineColor {string} color of connecting line, overrides dotOptions
   * @param lineWidth {number} width of connecting line, overrides dotOptions
   * @param featured {bool} is series present in featured section
   * @param selected {bool} is series shown as selected
   * @param labelText {string} text to be used as label
   * @param tooltipTitle {string} title to be used in tooltip
   */
  dataSeriesOptions: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    id: prop_types_1.string.isRequired,
    dot1Color: prop_types_1.string,
    dot1Radius: prop_types_1.number,
    dot1StokeWidth: prop_types_1.number,
    dot1StrokeColor: prop_types_1.string,
    dot2Color: prop_types_1.string,
    dot2Radius: prop_types_1.number,
    dot2StokeWidth: prop_types_1.number,
    dot2StrokeColor: prop_types_1.string,
    lineColor: prop_types_1.string,
    lineWidth: prop_types_1.number,
    featured: prop_types_1.bool,
    selected: prop_types_1.bool,
    labelText: prop_types_1.string,
    tooltipTitle: prop_types_1.string
  })),
  /**
   * Configuration options for dots
   * @param dot1Color {string} color of dot 1
   * @param dot1Radius {number} radius of dot 1
   * @param dot1StokeWidth {number} stroke width of dot 1
   * @param dot1StrokeColor {string} stroke color of dot 1
   * @param dot2Color {string} color of dot 2
   * @param dot2Radius {number} radius of dot 2
   * @param dot2StokeWidth {number} stroke width of dot 2
   * @param dot2StrokeColor {string} stroke color of dot 2
   * @param lineColor {string} color of connecting line
   * @param lineWidth {number} width of connecting line
   */
  dotOptions: (0, prop_types_1.shape)({
    dot1Color: prop_types_1.string,
    dot1Radius: prop_types_1.number,
    dot1StokeWidth: prop_types_1.number,
    dot1StrokeColor: prop_types_1.string,
    dot2Color: prop_types_1.string,
    dot2Radius: prop_types_1.number,
    dot2StokeWidth: prop_types_1.number,
    dot2StrokeColor: prop_types_1.string,
    lineColor: prop_types_1.string,
    lineWidth: prop_types_1.number
  }),
  /**
   * Configuration options for dropdown
   * @param enabled {bool} is changing selected item enabled
   * @param selectedItem1 {string} selected item for dropdown 1
   *  must be an exact match in value & format to a key in data array
   * @param selectedItem2 {string} selected item for dropdown 2,
   * must be an exact match in value & format to a key in data array
   * @param show {bool} are dropdowns visible
   * @param type {string} data type - 'items','linear','unformatted','percent','dollars','years',
   * 'yearly','months','monthly','quarters','quarterly','weeks','weekly','days','daily'
   */
  dropdownOptions: (0, prop_types_1.shape)({
    enabled: prop_types_1.bool,
    selectedItem1: prop_types_1.string,
    selectedItem2: prop_types_1.string,
    show: prop_types_1.bool,
    sort: (0, prop_types_1.oneOfType)([prop_types_1.bool, (0, prop_types_1.oneOf)(['ascending', 'descending'])]),
    type: (0, prop_types_1.oneOf)(exports.AXIS_TYPES)
  }),
  /** position of featured section - 'top' or 'bottom' */
  featuredPosition: (0, prop_types_1.oneOf)(constants_2.FEATURED_POSITIONS),
  /**
   * Configuration options for footer
   * @param fontSize {number} font size override of footer text
   * @param footnotes {object[]} footnotes to add to those found in the data
   * @param show {bool} is footer shown
   * @param showMetricFootnotes {bool} are footnotes from data series shown
   * @param sources {object[]} sources to add to those found in the data   *
   */
  footerOptions: (0, prop_types_1.shape)({
    fontSize: prop_types_1.number,
    footnotes: ChartWrapper_1.chartWrapperPropTypes.footnotes,
    show: ChartWrapper_1.chartWrapperPropTypes.showFooter,
    showMetricFootnotes: prop_types_1.bool,
    sources: ChartWrapper_1.chartWrapperPropTypes.footerSources
  }),
  /** Options for labels
   * @param maxWidth max width of label section
   * @param maxLines max lines to be shown per label when wrapping
   * @param color color for the labels
   * @param fontSize font size for the labels
   */
  labelOptions: (0, prop_types_1.shape)({
    maxWidth: prop_types_1.number,
    maxLines: prop_types_1.number,
    color: prop_types_1.string,
    fontSize: prop_types_1.number
  }),
  /** direction to sort data - 'ascending' or 'descending' */
  sort: (0, prop_types_1.oneOf)(constants_2.SORT_DIRECTIONS),
  /**
   * Chart wrapper subtitle options
   * @param fontSize {number} font size of title
   * @param text {string} text to be used as a subtitle
   */
  subtitleOptions: (0, prop_types_1.shape)({
    fontSize: ChartWrapper_1.chartWrapperPropTypes.subtitleFontSize,
    text: ChartWrapper_1.chartWrapperPropTypes.subtitle
  }),
  /**
   * Chart wrapper title options
   * @param fontSize {number} font size of title
   * @param text {string} text to be used as a title
   */
  titleOptions: (0, prop_types_1.shape)({
    fontSize: ChartWrapper_1.chartWrapperPropTypes.titleFontSize,
    text: ChartWrapper_1.chartWrapperPropTypes.title
  }),
  /**
   * Configuration options for tooltips
   * @param decimals {number} number of decimals to display
   * @param position {string} if the tooltip is above or below the bar - 'above' or 'below'
   * @param show {bool} should tooltips be shown
   * @param showSubtitle {bool} are subtitles shown inside the tooltip
   */
  tooltipOptions: (0, prop_types_1.shape)({
    decimals: prop_types_1.number,
    position: (0, prop_types_1.oneOf)(Tooltip_1.TOOLTIP_POSITIONS),
    show: prop_types_1.bool,
    showSubtitle: prop_types_1.bool
  }),
  /** height of chart */
  height: prop_types_1.number,
  /** width of chart */
  width: prop_types_1.number,
  /**
   * Configuration options for the xAxis
   * @param decimals {number} number of decimals to display
   * @param displayRangeMin {number,string} domain minimum to be used for the axis
   * @param displayRangeMax {number,string} domain maximum to be used for the axis
   * @param displayTicks {string[]} what positions to display axis - 'top','bottom'
   * @param floatingAxis {bool} allows the domain to dynamically adjust with selected data set
   * @param fontSize {number} font size of axis text
   * @param showGridlines {bool} should gridlines be shown
   * @param ticks {number[], string[]} override calculated ticks
   * @param type {string} data type - 'items','linear','unformatted','percent','dollars','years',
   * 'yearly','months','monthly','quarters','quarterly','weeks','weekly','days','daily'
   * @param textColor {string} axis label color
   */
  xAxisOptions: (0, prop_types_1.shape)({
    decimals: prop_types_1.number,
    displayRangeMin: (0, prop_types_1.oneOfType)([prop_types_1.number, prop_types_1.string]),
    displayRangeMax: (0, prop_types_1.oneOfType)([prop_types_1.number, prop_types_1.string]),
    displayTicks: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOf)(lodash_1.default.values(constants_2.AXIS_POSITIONS))),
    floatingAxis: prop_types_1.bool,
    fontSize: prop_types_1.number,
    showGridlines: prop_types_1.bool,
    ticks: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOfType)([prop_types_1.number, prop_types_1.string])),
    type: (0, prop_types_1.oneOf)(exports.AXIS_TYPES),
    textColor: prop_types_1.string
  }),
  customTooltip: prop_types_1.func
};
exports.default = DotPlot;